
const getCurrentGlobal = () => typeof window !== 'undefined' ? window : this;
let cachedHighCharts = {};

function backUpHighCharts() {
  const global = getCurrentGlobal();
  let highChartsTemp = undefined;
  if (typeof (global.Highcharts) !== 'undefined') {
    highChartsTemp = global.Highcharts;
    global.Highcharts = undefined;
  }
  return highChartsTemp;
}

function restoreHighCharts(backUp) {
  const global = getCurrentGlobal();
  global.Highcharts = backUp;
}

function getHighCharts() {
  if (cachedHighCharts.izendaHighCharts) {
    return cachedHighCharts.izendaHighCharts;
  }
  const highChartsBackup = backUpHighCharts();
  cachedHighCharts.izendaHighCharts = global.Highcharts = require('highcharts');
  require('highcharts-data');
  restoreHighCharts(highChartsBackup);
  return cachedHighCharts.izendaHighCharts;
}

function getTreeMap() {
  if (cachedHighCharts.treemap) {
    return cachedHighCharts.treemap;
  }
  const highChartsBackup = backUpHighCharts();
  const global = getCurrentGlobal();
  global.Highcharts = require('highcharts');
  cachedHighCharts.treemap = require('treemap');
  restoreHighCharts(highChartsBackup);
  return cachedHighCharts.treemap;
}

function getHeatMap() {
  if (cachedHighCharts.heatmap) {
    return cachedHighCharts.heatmap;
  }
  const highChartsBackup = backUpHighCharts();
  const global = getCurrentGlobal();
  global.Highcharts = require('highcharts');
  cachedHighCharts.heatmap = require('heatmap');
  restoreHighCharts(highChartsBackup);
  return cachedHighCharts.heatmap;
}

function getFunnel() {
  if (cachedHighCharts.funnel) {
    return cachedHighCharts.funnel;
  }
  const highChartsBackup = backUpHighCharts();
  const global = getCurrentGlobal();
  global.Highcharts = require('highcharts');
  cachedHighCharts.funnel = require('funnel');
  restoreHighCharts(highChartsBackup);
  return cachedHighCharts.funnel;
}

function getSolidGauge() {
  if (cachedHighCharts.solidGauge) {
    return cachedHighCharts.solidGauge;
  }
  const highChartsBackup = backUpHighCharts();
  const global = getCurrentGlobal();
  global.Highcharts = require('highcharts');
  cachedHighCharts.solidGauge = require('solidGauge');
  restoreHighCharts(highChartsBackup);
  return cachedHighCharts.solidGauge;
}

function getHighchartsMore() {
  if (cachedHighCharts.hightChartMore) {
    return cachedHighCharts.hightChartMore;
  }
  const highChartsBackup = backUpHighCharts();
  const global = getCurrentGlobal();
  global.Highcharts = require('highcharts');
  cachedHighCharts.hightChartMore = require('highcharts-more');
  restoreHighCharts(highChartsBackup);
  return cachedHighCharts.hightChartMore;
}

function getHighmaps() {
  if (cachedHighCharts.highmaps) {
    return cachedHighCharts.highmaps;
  }
  const highChartsBackup = backUpHighCharts();
  cachedHighCharts.highmaps = require('highmaps');
  restoreHighCharts(highChartsBackup);
  return cachedHighCharts.highmaps
}

// USE: "import {xxx as Highcharts} from 'wrappers/Izenda.Highcharts';"
export default {
  highcharts: getHighCharts(),
  treemap: getTreeMap(),
  heatmap: getHeatMap(),
  funnel: getFunnel(),
  solidGauge: getSolidGauge(),
  enhanceHighcharts: getHighchartsMore(),
  highmaps: getHighmaps()
}



// WEBPACK FOOTER //
// ./ui/wrappers/Izenda.Highcharts.js